import React from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Models
import mCompany from 'models/company';
// Custom
import { companiesShape } from 'constants/PropTypesShapes';
import CompanyItem from './CompanyItem';

class CompanyChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectCompany = this.handleSelectCompany.bind(this);
    this.handleValidate = this.handleValidate.bind(this);

    const { companyId } = this.props;
    this.state = {
      companyId,
    };
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers
  handleSelectCompany(companyId) {
    this.setState({ companyId });
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const { onValidate } = this.props;
    const { companyId } = this.state;
    onValidate(companyId);
    return true;
  }

  render() {
    const { companies } = this.props;
    const { companyId } = this.state;

    const sortedCompanies = mCompany.sortElements(companies.elements);

    return (
      <div className="row">
        {!!sortedCompanies && _map(sortedCompanies, (company) => (
          <div key={_toString(company.id)} className="col-12 col-md-6 pt-4">
            <CompanyItem
              company={company}
              withSelection
              selectedId={companyId}
              onSelect={this.handleSelectCompany}
            />
          </div>
        ))}
      </div>
    );
  }
}

CompanyChooseList.propTypes = {
  companies: companiesShape.isRequired,
  companyId: PropTypes.number,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

CompanyChooseList.defaultProps = {
  companyId: null,
};

const mapStateToProps = (state) => ({
  companies: state.company.list,
});

module.exports = connect(
  mapStateToProps,
)(CompanyChooseList);



// WEBPACK FOOTER //
// ./routes/app/routes/companies/assets/main/CompanyChooseList.js